const INDEX_ITEMS = [
  { title: 'IMDb TOP 250 合集', desc: '全球影迷票选的最伟大250部电影完整收录', count: '250部' },
  { title: '豆瓣9分以上神作', desc: '华语地区口碑最高的满分经典影片汇总', count: '186部' },
  { title: '诺兰导演作品全集', desc: '从追随到奥本海默，诺兰电影宇宙完全盘点', count: '12部' },
  { title: '奥斯卡最佳影片巡礼', desc: '历届奥斯卡最佳影片获奖作品全收录', count: '95部' },
  { title: '漫威电影宇宙合集', desc: '按时间线整理的漫威超级英雄电影完整观看顺序', count: '33部' },
  { title: '国产高分动作片精选', desc: '华语动作电影的巅峰之作，热血与情怀并存', count: '210部' },
  { title: '宫崎骏动画电影全集', desc: '吉卜力工作室经典动画一次看够', count: '23部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心整理的观影指南，一键发现好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="flex items-start gap-4 p-4 md:p-5 bg-background-200/40 rounded-lg border border-background-300/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-primary-500/10 text-primary-500">
                <i className="ri-folder-music-line text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-background-300/40 text-foreground-500 text-xs whitespace-nowrap flex-shrink-0">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}